import { Currency } from '../../common';

export const DOLLAR = '$';
export const DUE_UPON_RECEIPT_LABEL = 'Due upon receipt';
export const RECEIVED_LANDING_PAGE = 'https://www.stigg.io/';
export const DEFAULT_CURRENCY = Currency.USD;
